<template>
  <div id="flag-quiz-game">
    <router-view/>
    <a href="https://github.com/wentingliuu/flag-quiz-game" target="_blank" class="copy-right">©2022 WENTING LIU</a>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>